import { Page } from './page.model';
import { UserListDto } from '../dtos/user-list.dto';

export class UsersPage extends Page {
  content: Array<UserListDto> = [];
}
